module.exports = __webpack_public_path__ + "media/images/city/044-empire-state-building-4014f2389e3d0acd10b63654d41da097.svg";